import { render, staticRenderFns } from "./maintFile.vue?vue&type=template&id=6ca8f8d2&scoped=true&"
import script from "./maintFile.vue?vue&type=script&lang=js&"
export * from "./maintFile.vue?vue&type=script&lang=js&"
import style0 from "./maintFile.vue?vue&type=style&index=0&id=6ca8f8d2&scoped=true&lang=css&"
import style1 from "./maintFile.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca8f8d2",
  null
  
)

export default component.exports